import React, { useContext, useEffect, useRef } from 'react';
import { useNavigation, useIsFocused } from '@react-navigation/native';
import { AuthContext } from '../Context/AuthContext';
import { ExtrasContext } from '../Context/ExtrasContext';

const NetworkMonitor: React.FC = () => {
  const navigation = useNavigation();
  const isFocused = useIsFocused();
  const { auth } = useContext(AuthContext);
  const { networkAvailableGlobal, continueOffline, setContinueOffline } =
    useContext(ExtrasContext);

  // Use refs to track previous states
  const prevNetworkStateRef = useRef<boolean>(true);
  const prevAuthStateRef = useRef<boolean>(false);

  useEffect(() => {
    const isAuthenticated = !!(auth?.accessToken?.length > 0);
    const wasAuthenticated = prevAuthStateRef.current;
    const wasOnline = prevNetworkStateRef.current;

    // Update refs for next comparison
    prevNetworkStateRef.current = networkAvailableGlobal;
    prevAuthStateRef.current = isAuthenticated;

    if (!networkAvailableGlobal) {
      if (continueOffline) return;
      // Avoid stacking multiple navigations
      if (!isFocused) return;
      const timeout = setTimeout(() => {
        // We are outside the child AppStack navigator here, so we must
        // navigate via the parent (Root) and target the nested screen.
        // This prevents "action 'NAVIGATE' was not handled" errors.
        (navigation as any).navigate('Root', {
          screen: 'NoInternetScreen',
        });
      }, 1000);
      return () => clearTimeout(timeout);
    }
    // When back online, clear offline continuation state
    if (networkAvailableGlobal && continueOffline) {
      setContinueOffline(false);
    }
  }, [
    networkAvailableGlobal,
    continueOffline,
    auth,
    navigation,
    isFocused,
    setContinueOffline,
  ]);

  return null;
};

export default NetworkMonitor;
